module.exports = __webpack_public_path__ + "img/ysq.82bbdc9e.png";